require('./cardPINChangeInputs.override.scss');
require('./cardPINChangeInputs.scss');

const PropTypes = require('prop-types');

//@vendor
const React = require('react');
//@core
const {formatText, FormattedText } = require('core/i18n').i18n;
//@commons
const { OKInput } = require('commonsComponents/OKInput');
//@constants
const VALID_INPUT_REGEX = /^\d{0,4}$/;//(nicolas.olmos): we only need 4 numbers and be capable of delete them.

class cardPINInputs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newPin: props.immMinicardChangePIN.get('newPin'),
            newPinConfirmation: props.immMinicardChangePIN.get('newPinConfirmation')
        }

        this.handleNewPinBlur = this.handleNewPinBlur.bind(this);
        this.handleNewPinChange = this.handleNewPinChange.bind(this);
        this.handleNewPinConfirmationBlur = this.handleNewPinConfirmationBlur.bind(this);
        this.handleNewPinConfirmationChange = this.handleNewPinConfirmationChange.bind(this);
    }

    handleNewPinBlur(evt) {
        this.props.setNewPin(evt.target.value);
    }

    handleNewPinChange(evt) {
        const value = evt.target.value;
        if (VALID_INPUT_REGEX.test(value)) {
            this.setState({
                newPin: value
            });
        }
    }

    handleNewPinConfirmationBlur(evt) {
        this.props.setNewPinConfirmation(evt.target.value);
    }

    handleNewPinConfirmationChange(evt) {
        const value = evt.target.value;
        if (VALID_INPUT_REGEX.test(value)) {
            this.setState({
                newPinConfirmation: value
            });
        }
    }

    render() {
        const { immMinicardChangePIN } = this.props;

        const newPinLabel = formatText('cardPINChangeInputs-cardPINChangeInputs_newPinLabel');
        const newPinLabelRequired = `${newPinLabel} *`;

        const repeatNewPinLabel = formatText('cardPINChangeInputs-cardPINChangeInputs_repeatNewPinLabel');
        const repeatNewPinLabelRequired = `${repeatNewPinLabel} *`;

        const newPinErrorState = immMinicardChangePIN.get('isDirty') && immMinicardChangePIN.get('newPin') === '';
        const newPinErrorMessage = formatText('cardPINChangeInputs-cardPINChangeInputs_requiredMessage', [newPinLabel]);

        const newPinConfirmationRequired = immMinicardChangePIN.get('isDirty') && immMinicardChangePIN.get('newPinConfirmation') === '';
        const newPinConfirmationNotMatch = immMinicardChangePIN.get('isDirty') && !immMinicardChangePIN.get('newPinConfirmationIsValid');
        const errorMessageKey = newPinConfirmationRequired ? 'requiredMessage' : newPinConfirmationNotMatch ? 'errorMessage' : '';
        const newPinConfirmationErrorMessage = formatText(`cardPINChangeInputs-cardPINChangeInputs_${errorMessageKey}`, [repeatNewPinLabel]);

        return (
            <section className="card-pin-change-inputs">
                <header className="card-pin-change-inputs__title">
                    <FormattedText value="cardPINChangeInputs-cardPINChangeInputs_title" />
                </header>
                <div className="card-pin-change-inputs__input">
                    <OKInput
                        value={this.state.newPin}
                        label={newPinLabelRequired}
                        onBlur={this.handleNewPinBlur}
                        onChange={this.handleNewPinChange}
                        errorState={newPinErrorState}
                        errorMessage={newPinErrorMessage}
                    />
                </div>
                <div className="card-pin-change-inputs__input">
                    <OKInput
                        value={this.state.newPinConfirmation}
                        label={repeatNewPinLabelRequired}
                        onBlur={this.handleNewPinConfirmationBlur}
                        onChange={this.handleNewPinConfirmationChange}
                        errorState={newPinConfirmationRequired || newPinConfirmationNotMatch}
                        errorMessage={newPinConfirmationErrorMessage}
                    />
                </div>
            </section>
        );
    }
}

cardPINInputs.propTypes = {
    setNewPin: PropTypes.func,
    setNewPinConfirmation: PropTypes.func,
    immMinicardChangePIN: PropTypes.object.isRequired
};

module.exports = cardPINInputs;